<template>
  <section>
    <span
      class="text-weight-bolder"
      style="display: block; font-size: 16px; color: #21324a"
      >Treinamentos Associados</span
    >
    <q-table
      style="max-height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :columns="columns"
      class="tabela-tamanho-fixo my-sticky-header-table"
      no-data-label="Nenhum treinamento vinculado"
      row-key="name"
      color="primary"
      dense
      :pagination="pagination"
      :rows-per-page-label="'Linhas Por Página'"
      :rows-per-page-options="[10, 25, 50, 100]"
      :filter="filtrar"
    >
      <template v-slot:top-left>
        <span style="display: block; margin-left: -15px; color: #21324a"
          >Treinamentos vinculados ao usuário.</span
        >
      </template>
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-funcionarioDataRealizacao="props">
        <q-td>
          <span v-if="props.row.funcionarioDataRealizacao">{{
            props.row.funcionarioDataRealizacao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-grupos="props">
        <q-td>
          <section
            v-for="(grupo, index) in props.row.grupos"
            :key="index"
            class="column"
          >
            <span>
              {{ grupo.nome }}
            </span>
          </section>
        </q-td>
      </template>

      <template #body-cell-funcionarioDataExpiracao="props">
        <q-td>
          <span v-if="props.row.funcionarioDataExpiracao">{{
            props.row.funcionarioDataExpiracao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-funcionarioPresenca="props">
        <q-td>
          <span v-if="props.row.funcionarioPresenca == 1"> SIM</span>
          <span v-else>NÃO</span>
        </q-td>
      </template>
    </q-table>
  </section>
</template>

<script setup>
import { ref, onMounted, computed, defineProps, watch } from "vue";
import { useStore } from "vuex";

import { useQuasar } from "quasar";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const columns = [
  {
    name: "nome",
    label: "Treinamento",
    field: "nome",
    align: "left",
  },
  {
    name: "grupos",
    label: "Produtos Impactados",
    field: "grupos",
    align: "left",
  },
  {
    name: "funcionarioValidade",
    label: "Válido por (dias)",
    field: "funcionarioValidade",
    align: "left",
  },
  {
    name: "funcionarioDataRealizacao",
    label: "Realizado em",
    field: "funcionarioDataRealizacao",
    align: "left",
  },
  {
    name: "funcionarioDataExpiracao",
    label: "Válido até",
    field: "funcionarioDataExpiracao",
    align: "left",
  },
  {
    name: "funcionarioObrigatorio",
    label: "Obrigatório",
    field: "funcionarioObrigatorio",
    align: "left",
  },
  {
    name: "funcionarioPresenca",
    label: "Presença Confirmada?",
    field: "funcionarioPresenca",
    align: "left",
  },
  {
    name: "autenticacao",
    label: "Status",
    field: "autenticacao",
    align: "left",
  },
];

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 15,
});
const rows = ref([]);
const disable = ref(true);
const store = useStore();
const filtrar = ref("");
const quasar = useQuasar();

const getTreinamentos = async () => {
  disable.value = true;

  try {
    let response = await store.dispatch("user/getTreinamentosAssociados", {
      id: userId.value,
      nomeTreinamento: filtrar.value,
    });

    rows.value = response.data.treinamentos;

    disable.value = false;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(getTreinamentos);

watch(
  () => filtrar.value,
  () => {
    getTreinamentos();
  }
);
</script>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px


  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #EEF3FE

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
